export interface ShowcaseItem {
    /** The showcase item type. */
    type: ShowcaseType;
    /** The showcase item value. */
    value: unknown;
    /** The showcase item label. */
    label?: string;

    /**
     * The showcase tooltip to display.
     */
    tooltip?: string | null;

    /** The showcase item meta data. */
    meta: {
        default_grow_rate?: number;
    }
}

export enum ShowcaseType {
    CONSUMER_COUNT = 'consumer_count',
    POTENTIAL = 'potential',
    FIRST_THREE_CONSUMERS = 'first_three_consumers',
    PROFITABILITY = 'profitability'
}
